import React from 'react';
import { getCorpCode } from '../util/Application';
import {
    AUTOMATE_BASE_URL,
    IS_STAGING,
    JBL_WIDGET_BASE_URL,
    JBL_WIDGET_DEV_MODE,
    MTAS_BASE_URL,
    RAPIDSTOR_BASE_URL,
} from '../api/config';

// Dev-only — import.meta.env.DEV is false in any built bundle (including a
// local production build), so this never ships. Shows what the app is
// actually connected to right now, since env vars silently differ between
// local .env, ?staging=true, and whatever's baked into a given build.
const DebugBar: React.FC = () => {
    if (!import.meta.env.DEV) {
        return null;
    }

    return (
        <div className='sticky top-0 z-[70] flex flex-wrap items-center gap-x-4 gap-y-1 bg-black px-3 py-1.5 font-mono text-xs text-lime-400'>
            <span className='font-bold text-white'>DEBUG</span>
            <span>corp: {getCorpCode() ?? 'none'}</span>
            <span>staging: {String(IS_STAGING)}</span>
            <span>rapidstor: {RAPIDSTOR_BASE_URL}</span>
            <span>automate: {AUTOMATE_BASE_URL}</span>
            <span>mtas: {MTAS_BASE_URL}</span>
            <span>jbl widget: {JBL_WIDGET_BASE_URL}</span>
            <span>jbl dev mode: {String(JBL_WIDGET_DEV_MODE)}</span>
        </div>
    );
};

export default DebugBar;
